import { useTranslations } from "next-intl";

export const useCatMedicalCard = () => {
  const t = useTranslations("Libs.UI.Components.CatMedicalCard");
  const tActions = useTranslations("Shared.Actions");

  return {
    title: t("title"),
    allergiesLabel: t("allergiesLabel"),
    medicalConditionsLabel: t("medicalConditionsLabel"),
    editCopy: tActions("edit"),
    editAriaLabel: t("editAriaLabel"),
  };
};
